module.exports = __webpack_public_path__ + "static/media/mcfinny.6ef5a9ab.png";